"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function SvgComponent(props) {
    return React.createElement("svg", Object.assign({ viewBox: "0 0 512 512" }, props),
        React.createElement("path", { d: "M436,176a28,28,0,0,0-28,28V332a28,28,0,0,0,56,0V204A28,28,0,0,0,436,176Z" }),
        React.createElement("path", { d: "M76,176a28,28,0,0,0-28,28V332a28,28,0,0,0,56,0V204A28,28,0,0,0,76,176Z" }),
        React.createElement("path", { d: "M124,176V368a32,32,0,0,0,32,32h20v68a28,28,0,0,0,56,0V400h48v68a28,28,0,0,0,56,0V400h20a32,32,0,0,0,32-32V176Z" }),
        React.createElement("circle", { cx: 196, cy: 108, r: 12, style: {
                fill: "none"
            } }),
        React.createElement("circle", { cx: 316, cy: 108, r: 12, style: {
                fill: "none"
            } }),
        React.createElement("path", { d: "M384.22,136C376,106.71,356.42,81.69,330,65.23q-2.22-1.38-4.5-2.68T320.92,60L326,50.92l15.89-28.66a4.21,4.21,0,0,0-1.65-5.73,4.14,4.14,0,0,0-2-.53,4.21,4.21,0,0,0-3.69,2.17l-16.1,29.05-5.08,9.15c-1.6-.71-3.22-1.38-4.86-2s-3.28-1.27-4.95-1.86a143.1,143.1,0,0,0-95,0q-2.5.89-4.95,1.86c-1.64.66-3.26,1.33-4.86,2l-5.08-9.15-16.1-29a4.22,4.22,0,0,0-7.38,4.09L186,50.92,191.08,60q-2.33,1.22-4.6,2.51T182,65.23c-26.4,16.46-46,41.48-54.2,70.74a94.46,94.46,0,0,0-3.72,24H387.94A94.46,94.46,0,0,0,384.22,136ZM196,120a12,12,0,1,1,12-12A12,12,0,0,1,196,120Zm120,0a12,12,0,1,1,12-12A12,12,0,0,1,316,120Z" }));
}
exports.default = SvgComponent;
